import classNames from "classnames";
import React from "react";
import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { addAnchorTagToUrl, anchorScroll } from "./../../wix-rich-content-common";
import { ANCHOR_LINK } from "../dataHooks";
import styles from "../statics/link-viewer-scss";
const decorator = (anchorDecoration, element) => {
  const { anchor } = anchorDecoration.anchorData;
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      key: `anchor-${element?.key}`,
      target: "_self",
      href: `#viewer-${anchor}`,
      className: classNames(styles.link, styles.linkInViewer),
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        const anchorString = `viewer-${anchor}`;
        const element2 = document.getElementById(anchorString);
        addAnchorTagToUrl(anchorString);
        element2 && anchorScroll(element2);
      },
      "data-hook": ANCHOR_LINK
    },
    element
  );
};
const AnchorDecorator = {
  rule: (node) => !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.ANCHOR),
  decorate: ({ element, node }) => {
    const anchorDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.ANCHOR
    );
    return decorator(anchorDecoration, element);
  },
  priority: 1e3
};
var anchor_default = AnchorDecorator;
export {
  anchor_default as default
};
//# sourceMappingURL=anchor.js.map
